import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Client } from 'src/admin/users/types';

export const useClient = (
  clientId: string | undefined,
  options: { retry?: UseQueryOptions<Client>['retry'] } = {},
) => {
  const { data, isLoading, error, refetch } = useQuery<Client>({
    queryKey: ['clients', clientId],
    enabled: !!clientId,
    retry: options.retry,
  });

  return {
    client: data ?? null,
    isLoading,
    error,
    refetch,
  };
};
